// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3AecI","content":"styles_content__1bjYD","checkbox":"styles_checkbox__1iDm7","checkboxLabel":"styles_checkboxLabel__3dbO7"};